export default "__VITE_ASSET__BRIjHlRB__"